// extracted by mini-css-extract-plugin
export default {"notes-list-item":"NotesList_notes-list-item__OoxZm"};